<!-- <input type="file" (change)="fileChangeEvent($event)" /> -->
<div class="modal-body">
    <div id="accordion">
        <div id="headingOne">
            <div class="form-row mt-0 justify-content-start">
                <div class="col-md-auto col-6 m-mt-10">
                    <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomOut()">Zoom -</button>
                </div>
                <div class="col-md-auto col-6 m-mt-10 ">
                    <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomIn()">Zoom +</button>
                </div>
                <!-- <div class="col-md-auto col-auto">
                    <button class="btn btn-secondary" style="display: flex; height: 34px;
                    align-items: center;
                    gap: 5px;" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        <span class="d-flex">Filters</span>
                        <span class="material-icons d-flex" style="font-size: 19px">
                            tune
                        </span>
                    </button>
                </div> -->
                <div class="col-md-auto col-6 ml-auto">
                    <button type="submit" class="btn btn-cancel m-width-100 m-mt-10" (click)="close()">Cancel</button>
                </div>
                <div class="col-md-auto col-6">
                    <button type="submit" class="btn btn-light-orange m-width-100  m-mt-10" (click)="saveImageCropped()">Save</button>
                </div>
            </div>

        </div>
        <div id="collapseOne" class="collapse mt-2" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="form-row btn-cropper m-mt-20 align-item-center justify-content-start">
                <div class="col-md-auto col-6"><button class="btn btn-sm btn-secondary-gray m-width-100"
                        (click)="rotateLeft()">Rotate
                        left</button>
                </div>
                <div class="col-md-auto col-6"><button class="btn btn-sm btn-secondary-gray m-width-100"
                        (click)="rotateRight()">Rotate
                        right</button></div>
                <div class="col-md-auto col-6 m-mt-10"><button class="btn btn-sm btn-secondary-gray m-width-100"
                        (click)="flipHorizontal()">Flip
                        horizontal</button></div>
                <div class="col-md-auto col-6 m-mt-10"><button class="btn btn-sm btn-secondary-gray m-width-100"
                        (click)="flipVertical()">Flip
                        vertical</button>
                </div>
                <div class="col-md-auto col-8 m-mt-10">
                    <button class="btn btn-sm btn-secondary-gray m-width-100"
                        (click)="toggleContainWithinAspectRatio()">{{containWithinAspectRatio?'Fill Aspect
                        Ratio':'Contain
                        Within Aspect
                        Ratio'}}
                    </button>
                </div>
                <div class="col-md-auto col-4 m-mt-10">
                    <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="resetImage()">Reset
                        image</button>
                </div>
                <div class="col-md-auto col-6 m-mt-10">
                    <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomOut()">Zoom -</button>
                </div>
                <div class="col-md-auto col-6 m-mt-10 ">
                    <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomIn()">Zoom +</button>
                </div>
                <div class="col-md-auto col-12 m-mt-10">
                    <input [(ngModel)]="rotation" class="form-control" placeholder="Rotation" type="number"
                        (keyup)="updateRotation()" />
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="form-row btn-cropper m-mt-20 align-item-center justify-content-start">
        <div class="col-md-auto col-6"><button class="btn btn-sm btn-secondary-gray m-width-100"
                (click)="rotateLeft()">Rotate
                left</button>
        </div>
        <div class="col-md-auto col-6"><button class="btn btn-sm btn-secondary-gray m-width-100"
                (click)="rotateRight()">Rotate
                right</button></div>
        <div class="col-md-auto col-6 m-mt-10"><button class="btn btn-sm btn-secondary-gray m-width-100"
                (click)="flipHorizontal()">Flip
                horizontal</button></div>
        <div class="col-md-auto col-6 m-mt-10"><button class="btn btn-sm btn-secondary-gray m-width-100"
                (click)="flipVertical()">Flip
                vertical</button>
        </div>
        <div class="col-md-auto col-7 m-mt-10">
            <button class="btn btn-sm btn-secondary-gray m-width-100"
                (click)="toggleContainWithinAspectRatio()">{{containWithinAspectRatio?'Fill Aspect Ratio':'Contain
                Within Aspect
                Ratio'}}
            </button>
        </div>
        <div class="col-md-auto col-5 m-mt-10">
            <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="resetImage()">Reset image</button>
        </div>
        <div class="col-md-auto col-6 m-mt-10">
            <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomOut()">Zoom -</button>
        </div>
        <div class="col-md-auto col-6 m-mt-10 ">
            <button class="btn btn-sm btn-secondary-gray m-width-100" (click)="zoomIn()">Zoom +</button>
        </div>
        <div class="col-md-auto col-12 m-mt-10">
            <input [(ngModel)]="rotation" class="form-control" placeholder="Rotation" type="number"
                (keyup)="updateRotation()" />
        </div>
    </div> -->
    <div class="img-contenet">
        <div class="form-row mt-0 mt-md-4">
            <div class="col-md-7">
                <image-cropper *ngIf="isCropperVisible" [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="aspectRatio"
                    [resizeToWidth]="1024"
                    [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                    [style.display]="showCropper ? null : 'none'" format="png" (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)"
                    (loadImageFailed)="loadImageFailed()" [roundCropper]="fieldShapeId==2"></image-cropper>
            </div>
            <div class="col-md-5 col-12 text-center text-md-left">
                <div class="pad-5 text-center">
                    <div class="text-center fs-15 font-weight-bold mb-2">
                        Cropped Image
                    </div>
                    <img [src]="croppedImage" [class]="fieldShapeId==2?'round w-100':'sqare w-100'" 
                        [style.border]="croppedImage ? '1px solid #cacaca' : 'none'" alt="Cropped Image"/>
                </div>
            </div>
        </div>
    </div>
    <div class="form-row mt-3 align-item-center justify-content-start">

    </div>

</div>